function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ".authenticated-container" + shadowSelector + " {min-width: var(--temp-min-width);}.page-container" + shadowSelector + " {margin: 0 auto;}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet];